export default __webpack_public_path__ + "static/media/arrow.8c42ed39.svg";